import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selectors from '../../selectors/authentication';
import { inputForgotPassword, submitForgotPasswordForm } from '../../actions/authentication';
import { bindActionCreators } from 'redux';
import ForgotPasswordForm from '../../components/application/authentication/ForgotPasswordForm';

class ForgotPassword extends Component {
    _onSubmit = () => this.props.submitForgotPasswordForm(this.props.email, this.props.password);
    render() {
        return (
            <ForgotPasswordForm
                canSubmit={this.props.canSubmit}
                email={this.props.email}
                onInput={this.props.inputForgotPassword}
                onSubmit={this._onSubmit}
                loading={this.props.loading}
                errorText={this.props.error}
            />
        );
    }
}

const mapStateToProps = state => ({
    email: selectors.emailSelector(state),
    loading: selectors.isSubmittingSelector(state),
    canSubmit: selectors.canSubmitForgotPassword(state),
    error: selectors.errorSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ inputForgotPassword, submitForgotPasswordForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
